import { Box, Input, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import { AppRoutes } from '@utils/appRoutes';
import CuminButton from '@components/Button';
import useAuth from '@utils/useAuth';
import { snackbarInfo } from 'store/utils';

import ExitIntentLogoOne from '@public/assets/svg/ExitIntentLogoOne.svg';
import ExitIntentLogoTwo from '@public/assets/svg/ExitIntentLogoTwo.svg';

import { useStyles } from '../useStyles';

const CopyCodeSection = () => {
  const router = useRouter();
  const classes = useStyles();
  const { detectedCountryCode: countryCode } = useAuth();

  const CODE = 'SHARE15';

  const onClickViewPlan = () => {
    router.push(`/${countryCode}${AppRoutes.ORDER_STEP_ONE}`);
  };

  return (
    <Box className={classes.rightContainer}>
      <Box sx={{ position: 'relative' }}>
        <Box className={classes.logoOne}>
          <ExitIntentLogoOne />
        </Box>
        <Typography
          variant="h2"
          align="center"
          color="cinnamon.main"
          className={classes.mobDisplayNone}
        >
          Awesome!
        </Typography>
        <Box className={classes.logoTwo}>
          <ExitIntentLogoTwo />
        </Box>
      </Box>
      <Typography
        variant="body2"
        align="center"
        color="garamMasala.main"
        m="30px 0"
        className={classes.mobDisplayNone}
      >
        Your discount code is here! Now let’s get something delicious to eat!
      </Typography>
      <Typography
        variant="body2"
        align="center"
        color="cumin.main"
        m="5px 0 20px"
        className={classes.dTDisplayNone}
      >
        Here’s your discount code! Now let’s get something to eat!
      </Typography>
      <Box className={classes.copyGiftCodeFieldWrapper}>
        <Input
          disableUnderline
          value={CODE}
          className={classes.giftCodeField}
        />
        <CuminButton
          color="turmeric"
          variant="contained"
          textColor="garamMasala.main"
          borderRadius="24"
          className={classes.coptGiftCodebtn}
          onClick={() => {
            navigator.clipboard.writeText(CODE);
            snackbarInfo({
              message: 'Gift Code Copied',
              type: 'success',
            });
          }}
        >
          Copy
        </CuminButton>
      </Box>
      <CuminButton
        color="cinnamon"
        variant="contained"
        textColor="whitePepper.main"
        width="240px"
        height="48"
        borderRadius="24"
        className={classes.discountBtn}
        onClick={onClickViewPlan}
      >
        View Plans
      </CuminButton>
    </Box>
  );
};

export default CopyCodeSection;
